/* L&E - ancres internes vers une section de la page d'accueil.

   Trois pieges du theme, tous traites ici :

   1. Shopify enveloppe chaque section dans un id de la forme
      shopify-section-template--30898759958876__ma_section. Le prefixe
      "template--<numero>__" change des que le modele est recree ou que le
      theme est copie ou republie : ecrire cet id en dur dans un bouton,
      c'est un lien qui casse a la prochaine copie de theme.

   2. Le theme met html et body en overflow:hidden et fait defiler
      .page-wrapper. window.scrollTo() n'a donc aucun effet ; il faut
      passer par scrollIntoView, qui trouve tout seul le bon conteneur.

   3. L'en-tete collant est le <header> de groupe, pas #header-component
      (qui est en position static). On mesure donc le premier element
      reellement colle.

   Cadrage : on cale le BAS de la section sur le bas de l'ecran, pour
   laisser apparaitre ce qui la precede et donner envie de remonter.
   Si la section est plus haute que l'ecran (cas du mobile), ce cadrage
   ferait sortir son debut par le haut : on repasse alors sur un calage
   par le haut, sous l'en-tete collant.

   Usage : dans le champ Lien d'un bouton, ecrire
   #shopify-section-<cle-de-section>, par exemple
   #shopify-section-collection_list_ntEyRk

   Si l'ancre existe deja telle quelle dans la page, on laisse le
   comportement natif du navigateur. */

(function () {
  /* Marge a laisser sous la section quand on la cale par le bas. */
  var MARGE_BAS = 0;

  function decalageEntete() {
    var candidats = document.querySelectorAll('header, #header-component');
    var maxi = 0;
    for (var i = 0; i < candidats.length; i++) {
      var position = window.getComputedStyle(candidats[i]).position;
      if (position !== 'sticky' && position !== 'fixed') continue;
      var hauteur = candidats[i].getBoundingClientRect().height;
      if (hauteur > maxi) maxi = hauteur;
    }
    return Math.round(maxi);
  }

  function cibleDe(href) {
    if (!href || href.charAt(0) !== '#' || href.length < 2) return null;
    var id = href.slice(1);

    if (document.getElementById(id)) return null;
    if (id.indexOf('shopify-section-') !== 0) return null;

    var cle = id.slice('shopify-section-'.length);
    return document.querySelector(
      '[id^="shopify-section-"][id$="__' + cle + '"]'
    );
  }

  function hauteurVisible() {
    return window.innerHeight || document.documentElement.clientHeight;
  }

  function amener(cible) {
    var entete = decalageEntete();
    var hauteurCible = cible.getBoundingClientRect().height;
    var placeDisponible = hauteurVisible() - entete - MARGE_BAS;

    if (hauteurCible <= placeDisponible) {
      /* La section tient a l'ecran : on cale son bas en bas de l'ecran. */
      cible.style.scrollMarginTop = '';
      cible.style.scrollMarginBottom = MARGE_BAS + 'px';
      cible.scrollIntoView({ behavior: 'smooth', block: 'end' });
      return;
    }

    /* Trop haute : on cale son haut sous l'en-tete collant. */
    cible.style.scrollMarginBottom = '';
    cible.style.scrollMarginTop = entete + 'px';
    cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (evenement) {
    if (evenement.defaultPrevented || evenement.button !== 0) return;
    if (evenement.metaKey || evenement.ctrlKey || evenement.shiftKey) return;
    if (!evenement.target || !evenement.target.closest) return;

    var lien = evenement.target.closest('a[href^="#"]');
    if (!lien) return;

    var cible = cibleDe(lien.getAttribute('href'));
    if (!cible) return;

    evenement.preventDefault();
    amener(cible);
  });
})();
